import type { RootState } from 'src/redux';

import { selectFlags } from './select-flags';

export const shouldExposeUnlabelledVideosView = (state: RootState) =>
  !!selectFlags(state)['labels-sidebar-unlabelled-videos-view'];
